/**
 * @generated SignedSource<<196cebb3cee995d3b5c16f02d939e36e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ReportUserFileType = "EXPORT" | "INPUT" | "OUTPUT" | "SOURCE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ReportStatusDetails_report$data = {
  readonly id: string;
  readonly errors: any | null;
  readonly periodStart: any | null;
  readonly periodEnd: any | null;
  readonly reportUserFiles: {
    readonly nodes: ReadonlyArray<{
      readonly type: ReportUserFileType;
      readonly userFile: {
        readonly id: string;
        readonly name: string;
        readonly meta: any | null;
      } | null;
    }>;
  };
  readonly " $fragmentType": "ReportStatusDetails_report";
};
export type ReportStatusDetails_report$key = {
  readonly " $data"?: ReportStatusDetails_report$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReportStatusDetails_report">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReportStatusDetails_report",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "errors",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "periodStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "periodEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ReportUserFilesConnection",
      "kind": "LinkedField",
      "name": "reportUserFiles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReportUserFile",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "UserFile",
              "kind": "LinkedField",
              "name": "userFile",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "meta",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Report",
  "abstractKey": null
};
})();

(node as any).hash = "5975045782ea98b89e7367dcda172016";

export default node;
